'use client'

import { Builder } from '@builder.io/react'

import { AnimatedSlider } from './AnimatedSlider'

Builder.registerComponent(AnimatedSlider, {
  name: 'AnimatedSlider',
  inputs: [
    {
      name: 'isDarkFade',
      type: 'boolean',
      friendlyName: 'Fade edges to black',
    },
    {
      name: 'sliders',
      type: 'list',
      subFields: [
        {
          name: 'imageSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
        },
        {
          name: 'reverseDirection',
          friendlyName: 'slide left to right',
          type: 'boolean',
        },
      ],
      defaultValue: [],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/keyframes.svg',
})
